import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateSiteDocumentsCache,
  SiteDocumentsCacheEvents,
} from '@monorepo/shared/cacheRegisters/documents/siteDocumentsCacheRegister';
import { DocumentFileResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type UseUpdateSiteDocumentParams = {
  config?: MutationConfig<DocumentFileResponse, Api.ErrorResponse>;
};

export const useUpdateSiteDocument = (params?: UseUpdateSiteDocumentParams) =>
  useMutation(Api.updateProjectDocument, {
    ...params?.config,
    onSuccess: (data, vars) => {
      const event =
        vars.document.folderId !== undefined
          ? SiteDocumentsCacheEvents.MOVE
          : SiteDocumentsCacheEvents.UPDATE;
      invalidateSiteDocumentsCache(event, {
        organizationId: vars.organizationId,
        projectId: vars.projectId,
      });
      return params?.config?.onSuccess?.(data, vars);
    },
  });
